import React from "react"

import Form from "./Form"

const NewOrganization = params => {
  return <Form {...params} />
}

export default NewOrganization
